// .no-main--contact 콜라주 마우스 3D 패럴랙스
// - 섹션 내부에서만 동작, data-depth 로 이미지별 강도/방향 제어
// - gsap.quickTo 로 rotationX/rotationY/x/y 만 제어 → perspective 포함 matrix3d 로 입체 회전
// - 1024 이하 비활성 + transform 초기화, 리사이즈 중복 바인딩 방지
export function initContactCollage(root = ".no-main--contact") {
  const section = document.querySelector(root);
  if (!section) return;
  if (typeof window.gsap === "undefined") return;

  const images = [...section.querySelectorAll(".visual-img")];
  if (!images.length) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const mqDesktop = window.matchMedia("(min-width: 1025px)");

  // depth(0.04~0.1) 기준 환산값 — depth=0.1 일 때 약 14°, 60px 이동
  const ROTATE_SCALE = 140; // deg = nx * depth * ROTATE_SCALE
  const TRAVEL_SCALE = 600; // px  = nx * depth * TRAVEL_SCALE
  const PERSPECTIVE = 900;
  const QUICK = { duration: 1, ease: "power3.out" };

  // 이미지별 quickTo 핸들러 (rotation/x/y 만 제어 → 기존 transform 보존)
  // depth 부호와 무관하게 "같은 방향"으로 이동하도록 절댓값(강도)만 사용
  const movers = images.map((el) => ({
    depth: Math.abs(parseFloat(el.dataset.depth) || 0),
    rxTo: gsap.quickTo(el, "rotationX", QUICK),
    ryTo: gsap.quickTo(el, "rotationY", QUICK),
    xTo: gsap.quickTo(el, "x", QUICK),
    yTo: gsap.quickTo(el, "y", QUICK),
  }));

  function onMouseMove(e) {
    const rect = section.getBoundingClientRect();
    // 섹션 중심 기준 정규화 오프셋 (-1 ~ 1)
    const nx = (e.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
    const ny = (e.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);

    movers.forEach((m) => {
      // 모든 이미지가 마우스 방향으로 동일하게 이동·기울기, 강도만 depth 로 차등
      m.ryTo(nx * m.depth * ROTATE_SCALE);
      m.rxTo(-ny * m.depth * ROTATE_SCALE);
      m.xTo(nx * m.depth * TRAVEL_SCALE);
      m.yTo(ny * m.depth * TRAVEL_SCALE);
    });
  }

  function reset() {
    // 섹션 이탈/정지 시 원위치로 부드럽게 복귀 (튐 방지)
    movers.forEach((m) => {
      m.rxTo(0);
      m.ryTo(0);
      m.xTo(0);
      m.yTo(0);
    });
  }

  let bound = false;

  function enable() {
    if (bound) return;
    bound = true;
    // perspective 를 각 이미지 transform 에 포함 → matrix3d 입체 회전
    gsap.set(images, {
      transformPerspective: PERSPECTIVE,
      transformOrigin: "center 50%",
    });
    section.addEventListener("mousemove", onMouseMove);
    section.addEventListener("mouseleave", reset);
  }

  function disable() {
    if (!bound) return;
    bound = false;
    section.removeEventListener("mousemove", onMouseMove);
    section.removeEventListener("mouseleave", reset);
    gsap.set(images, {
      rotationX: 0,
      rotationY: 0,
      x: 0,
      y: 0,
      clearProps: "transform",
    });
  }

  function applyMode() {
    if (mqDesktop.matches && !reduceMotion.matches) {
      enable();
    } else {
      disable();
    }
  }

  // matchMedia change 로만 모드 전환 → resize 중복 바인딩 없음
  const onChange = () => applyMode();
  if (typeof mqDesktop.addEventListener === "function") {
    mqDesktop.addEventListener("change", onChange);
    reduceMotion.addEventListener("change", onChange);
  } else if (typeof mqDesktop.addListener === "function") {
    mqDesktop.addListener(onChange);
    reduceMotion.addListener(onChange);
  }

  applyMode();
}
